module.exports = __webpack_public_path__ + "static/WelcomeToElk0-0dc84c700620c6119461df2cab5168fa.webp";